"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPc = isPc;
const PAGE_TYPE = {
    H5: 1,
    PC: 10
};
function isPc() {
    let route = null;
    if (window.FEGORender) {
        const { store } = window.FEGORender;
        route = store.route;
    }
    else {
        const { app: { project } } = window.FEGOEditor;
        route = project.route;
    }
    return (route === null || route === void 0 ? void 0 : route.now.pageType) === PAGE_TYPE.PC;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUtBLG9CQVlDO0FBakJELE1BQU0sU0FBUyxHQUFHO0lBQ2QsRUFBRSxFQUFFLENBQUM7SUFDTCxFQUFFLEVBQUUsRUFBRTtDQUNULENBQUM7QUFFRixTQUFnQixJQUFJO0lBQ2hCLElBQUksS0FBSyxHQUFRLElBQUksQ0FBQztJQUN0QixJQUFLLE1BQWMsQ0FBQyxVQUFVLEVBQUUsQ0FBQztRQUM3QixNQUFNLEVBQUUsS0FBSyxFQUFFLEdBQUksTUFBYyxDQUFDLFVBQVUsQ0FBQztRQUM3QyxLQUFLLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQztJQUN4QixDQUFDO1NBQU0sQ0FBQztRQUNKLE1BQU0sRUFDRixHQUFHLEVBQUUsRUFBRSxPQUFPLEVBQUUsRUFDbkIsR0FBSSxNQUFjLENBQUMsVUFBVSxDQUFDO1FBQy9CLEtBQUssR0FBRyxPQUFPLENBQUMsS0FBSyxDQUFDO0lBQzFCLENBQUM7SUFDRCxPQUFPLENBQUEsS0FBSyxhQUFMLEtBQUssdUJBQUwsS0FBSyxDQUFFLEdBQUcsQ0FBQyxRQUFRLE1BQUssU0FBUyxDQUFDLEVBQUUsQ0FBQztBQUNoRCxDQUFDIn0=